var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaperAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    stroke: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Send") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.8,4.2l-1.4,0.5L1.9,12l3.8,1.9l0,0c0.1,0.1,0.2,0.2,0.2,0.3l1.1,6.3l2-3.5l0,0c0.1-0.2,0.3-0.2,0.5-0.1 c0,0,0.1,0,0.1,0.1l5.5,5.4L22.8,4.2L22.8,4.2z M21.2,4.1l2.1-0.8c0.1,0,0.2,0,0.3,0c0.2,0.1,0.3,0.3,0.2,0.5l0,0l-8.2,19.2 c0,0,0,0.1-0.1,0.1c-0.1,0.1-0.4,0.1-0.5,0l0,0l-5.5-5.5l-2.2,4c0,0.1-0.1,0.2-0.3,0.2c-0.2,0-0.4-0.1-0.4-0.3l0,0l-1.3-7.1 l-4.4-2.2c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.2,0-0.4,0.2-0.5l0,0L21.2,4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.4,13.9c-0.2,0.1-0.2,0.3-0.1,0.5c0.1,0.2,0.3,0.2,0.5,0.1L23.6,3.9c0.2-0.1,0.2-0.3,0.1-0.5 c-0.1-0.2-0.3-0.2-0.5-0.1L5.4,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.7,3.9c0.1-0.1,0.2-0.4,0-0.5c-0.1-0.1-0.4-0.2-0.5,0L9.1,16.8c-0.1,0.1-0.2,0.4,0,0.5s0.4,0.2,0.5,0 L23.7,3.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperAirplane);
export default __webpack_public_path__ + "static/media/icon-paper-airplane.3a273a4d7b7e9ea098cb8c75382b4dd9.svg";
export { ForwardRef as ReactComponent };